import React from 'react';
import Hero from '../components/sections/Hero';
import Features from '../components/sections/Features';
import CallToAction from '../components/sections/CallToAction';

const HomePage = () => {
  return (
    <>
      <Hero />
      <Features />
      <CallToAction />
    </>
  );
};

export default HomePage;
